import { FC, useCallback, useEffect, useState } from 'react';
import { Image, StyleSheet, Text, View } from 'react-native';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import NewLayout from '../../WebLayout/NewLayout/NewLayout';
import SportNewItem from './components/SportNewsItem';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../services/redux/store';
import { IS_WEB } from '../../constants/platform';
import { STYLE_VARS } from '../../constants/style-vars';
import { addBase64Prefix } from '../../services/addBase64Prefix';
import { search_white } from '../../assets/base64';
import { TextInput } from '../../components/TextInput/TextInput';
import { COLORS, FONTS } from '../../constants';
import { INew } from '../../types';
import { NewApi } from '../../services/api';
import { Loading } from '../../components';
import { Button } from '../../components/Button';
import { NewsFilter, clearNewsFilter, setLoadingNews, setNews, setNewsFilter, setTotal } from '../../services/redux/reducers/NewsSlice';
import { debounce } from 'lodash';

const SportNews: FC = () => {
  const isDesktop = useIsDesktop();
  const dispatch = useDispatch();

  const { newsFilter, newsData, total, isLoading } = useSelector(
    (state: RootState) => state.newsReducer
  );

  const getNews = useCallback(
    async (props: NewsFilter) => {
      try {
        dispatch(setLoadingNews(true));
        const res = await NewApi.getNews(props);
        dispatch(setNews(res.data.news));
        dispatch(setTotal(res.data.total));
      } catch (error: any) {
        console.log(error);
      } finally {
        dispatch(setLoadingNews(false));
      }
    }, [dispatch]
  )

  const handleLoadmore = useCallback(async () => {
    if (newsData.length < total) {
      dispatch(
        setNewsFilter({
          ...newsFilter,
          page: Math.ceil(newsData.length / 6) + 1,
        })
      );
      try {
        dispatch(setLoadingNews(true));
        const res = await NewApi.getNews({
          ...newsFilter,
          page: Math.ceil(newsData.length / 6) + 1,
        });
        dispatch(setNews([...newsData, ...res.data.news]));
        dispatch(setTotal(res.data.total));
      } catch (error: any) {
        console.log(error);
      } finally {
        dispatch(setLoadingNews(false));
      }
    }
  }, [newsData, total, dispatch, newsFilter]);

  useEffect(() => {
    dispatch(clearNewsFilter());
    getNews({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSearch = useCallback(
    (text: string) => {
      dispatch(setNews([]));
      getNews({
        ...newsFilter,
        page: 1,
        search: text,
      });
      dispatch(
        setNewsFilter({
          ...newsFilter,
          page: 1,
          search: text,
        })
      );
    },
    [newsFilter, dispatch, getNews]
  );

  const debouncedSearch = debounce(handleSearch, 500);

  if (isDesktop()) {
    return (
      <NewLayout
        title="Sports News"
        icon={require('../../assets/news.png')}
        haveGoBackButton={false}
        havePromotion={false}
        haveTitleBottomLine={false}
      >
        <View
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            marginBottom: 13,
          }}
        >
          <Image
            source={
              IS_WEB
                ? addBase64Prefix(search_white)
                : require('../../assets/search_white.png')
            }
            style={{
              width: 20,
              height: 20,
              tintColor: STYLE_VARS.primaryColor,
              marginEnd: 5,
            }}
          />
          <View style={{ flex: 1 }}>
            <TextInput
              placeholder={'SEARCH'}
              placeholderTextColor={STYLE_VARS.primaryColor}
              onChangeText={debouncedSearch}
              style={{
                fontFamily: FONTS.IowanOldStyleBTRoman,
                fontSize: 13,
                color: STYLE_VARS.primaryColor,
              }}
            />
          </View>
        </View>
        <View style={styles.newWrapper}>
          {newsData.map((newItem) => (
            <View style={{ width: '50%', paddingEnd: 60, alignSelf: 'stretch' }}>
              <SportNewItem item={newItem} key={newItem.id} />
            </View>
          ))}
        </View>
        {(isLoading === false && newsData.length === 0 ) 
          ? <View style={styles.noDataWrapper}>
              <Text style={[styles.noDataText, {fontSize: 20}]}>
                THERE ARE CURRENTLY NO NEWS
              </Text>
            </View>
          : <></>
        }
        {isLoading && <Loading style={{ paddingVertical: 30 }} />}
        {total > newsData.length && (
          <View style={{ marginHorizontal: 'auto' }}>
            <Button
              style={STYLE_VARS.blueButton}
              text="VIEW MORE"
              onPress={handleLoadmore}
              disabled={isLoading}
            />
          </View>
        )}
      </NewLayout>
    );
  }

  return <></>;
};

export default SportNews;

const styles = StyleSheet.create({
  newWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: 35,
  },
  noDataWrapper: {
    flexDirection: 'row',
    justifyContent: 'center',
    paddingVertical: 20
  },
  noDataText: {
    color: COLORS.GREEN,
    textTransform: 'uppercase',
    fontFamily: FONTS.AvenirMedium,
  },
});
